import React, { useEffect } from "react";
import { Card } from "antd";
import { useLocation, useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { getCmsData } from "../../../redux/action/profile/getProfileAction";
import dayjs from "dayjs";

const CMS = () => {
  const location = useLocation();
  const isAbout = location?.pathname.includes("about");
  const isPrivacy = location?.pathname.includes("privacy");
  const dispatch = useDispatch();

  const data = useSelector((store) => store.getCmsData?.data);
  const { isLoading } = useSelector((store) => store.getCmsData);
  const type = isAbout ? 1 : isPrivacy ? 2 : 3;

  useEffect(() => {
    dispatch(getCmsData(type));
  }, [location?.pathname, dispatch, type]);

  const title = isAbout
    ? "About US"
    : isPrivacy
    ? "Privacy Policy"
    : "Terms & Conditions";

  return (
    <div className="privacy-container">
      <Card className="privacy-card" loading={isLoading}>
        <p className="profileMainHeading">{title}</p>
        {/* <p className="profileSubHeading">
          Last Updated:{" "}
          {data?.created_at ? dayjs(data?.created_at).format("MM-DD-YYYY") : ""}
        </p> */}
        <div
          className="content-display"
          dangerouslySetInnerHTML={{ __html: data?.content_en }}
        />
      </Card>
    </div>
  );
};

export default CMS;
